var render = function render(){var _vm=this,_c=_vm._self._c;return _c('active-remote-connections',{attrs:{"page":_vm.page,"items-per-page":_vm.itemsPerPage,"search":_vm.search,"sort-by":_vm.sortBy,"sort-desc":Array.isArray(_vm.sortDesc) ? _vm.sortDesc : [_vm.sortDesc && _vm.sortDesc.length > 0 ? _vm.sortDesc === 'true' : true],"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }